import ArrowUpRight from "@untitled-ui/icons-react/build/esm/ArrowUpRight";
import { useCallback } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  doSearch,
  SEARCH_TYPES,
  setCurrentInputQuery,
  setQueryValue as setQueryValueRedux,
  setSearchType,
  setSortBy,
} from "../../../../../store/reducer/_searchReducer";
import { PDLButton, PDLTypography } from "../../../dna";
import "./index.scss";

const HomeArticles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewMore = useCallback(() => {
    const queryValue = '"Artigo publicado"';
    const searchType = SEARCH_TYPES.doutrinas;

    dispatch(setCurrentInputQuery(queryValue));
    dispatch(setSearchType(searchType.id));
    dispatch(setSortBy("data"));
    dispatch(setQueryValueRedux(queryValue));
    dispatch(doSearch({ query: queryValue, searchType, page: 1 }));
    navigate("/resultados");
  }, [dispatch, navigate]);

  return (
    <Container fluid className="pdl_component_home_articles">
      <Row className="d-flex flex-row flex-md-nowrap gap-3">
        <Col xs={12} className="flex-shrink-1">
          <Card className="h-100">
            <div
              className="cardImage card-img-top"
              style={{
                backgroundImage:
                  "url(./images/generic/jurisprudencia_contratos.png)",
              }}
            ></div>
            <Card.Body className="p-4" style={{ cursor: "pointer" }}>
              <a
                href="http://plataforma.lex.com.br/doutrinas/DoutrinaComercial274"
                rel="noopener noreferrer"
                className="text-decoration-none text-reset d-block"
              >
                <div className="d-flex flex-row flex-nowrap gap-3 align-items-top justify-content-between mb-1">
                  <PDLTypography as="h5" display size="xs" weight="semibold">
                    Os Impactos da Tecnologia nas Relações Sociais e
                    Empresariais
                  </PDLTypography>
                  <ArrowUpRight />
                </div>
                <PDLTypography size="md">
                  Entenda as mudanças e principais decisões que afetam o
                  ambiente corporativo.
                </PDLTypography>
              </a>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} className="flex-shrink-1">
          <Card className="h-100">
            <a
              href="http://plataforma.lex.com.br/doutrinas/DoutrinaComercial363"
              rel="noopener noreferrer"
              className="text-decoration-none text-reset"
              style={{ display: "block", height: "100%" }}
            >
              <div
                className="cardImage card-img-top"
                style={{
                  backgroundImage:
                    "url(./images/generic/reformas_legislativas.png)",
                }}
              ></div>
              <Card.Body className="p-4">
                <div className="d-flex flex-row flex-nowrap gap-3 align-items-top justify-content-between mb-1">
                  <PDLTypography as="h5" display size="xs" weight="semibold">
                    As Novas Tecnologias e os Desafios do Direito do Consumidor
                  </PDLTypography>
                  <ArrowUpRight />
                </div>
                <PDLTypography size="md">
                  Um resumo das principais alterações e como se preparar.
                </PDLTypography>
              </Card.Body>
            </a>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="text-center mt-5">
          <PDLButton variant="primary" onClick={handleViewMore}>
            Ver mais
          </PDLButton>
        </Col>
      </Row>
    </Container>
  );
};

export default HomeArticles;
